import * as types from './mutation-types'
let defaultObject = () => ({
  data: {
    name: ''
  }
})

export default {
  [types.SET_HOTEL_ACCOMMODATION] (state, payload) {
    if (payload === null) {
      payload = defaultObject()
    }
    state.accommodation = payload
  },
  [types.SET_HOTEL_ACCOMMODATIONS] (state, payload) {
    state.accommodations = payload.data
    state.pagination = payload.meta.pagination
  }
}
